import React from 'react';
import { Text, LinearProgressBar, Box, Badge, Heading } from '@wix/design-system';
import { StatusWarningFilledSmall } from '@wix/wix-ui-icons-common';
import { getDeleteModalTitle } from './getDeleteModalTitle';
export const DeleteInProgressModalContent = _ref => {
  let {
    progress,
    usedFilesCount,
    formatMessage
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    margin: "12px",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(LinearProgressBar, {
    value: progress * 100
  }), usedFilesCount ? /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Badge, {
    skin: "warning",
    type: "transparent"
  }, /*#__PURE__*/React.createElement(StatusWarningFilledSmall, {
    size: 18
  })), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, formatMessage({
    id: 'files-manager.delete-permanently-loader.step-two'
  }, {
    numberofFiles: usedFilesCount
  }))) : /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, formatMessage({
    id: 'files-manager.delete-permanently-loader.step-delete'
  }, {
    numberofFiles: usedFilesCount
  })));
};
export const getDeleteInProgressModalOptions = _ref2 => {
  let {
    isSiteFilesEntry,
    usedFilesCount,
    selectedItemsCount,
    progress,
    onAfterClose,
    formatMessage
  } = _ref2;
  return {
    customLayout: true,
    hideFooter: true,
    showHeaderDivider: false,
    showFooterDivider: false,
    shouldDisplayCloseButton: false,
    subtitle: /*#__PURE__*/React.createElement(DeleteInProgressModalContent, {
      usedFilesCount: usedFilesCount,
      selectedItemsCount: selectedItemsCount,
      progress: progress,
      formatMessage: formatMessage
    }),
    title: /*#__PURE__*/React.createElement(Heading, {
      as: "h2",
      size: "large"
    }, getDeleteModalTitle(formatMessage, isSiteFilesEntry, selectedItemsCount)),
    onAfterClose
  };
};
//# sourceMappingURL=getDeleteInProgressModalOptions.js.map